import { Add, DoubleArrow, Edit} from '@mui/icons-material';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from '@mui/material';
import React,{useState,useEffect} from 'react'
import SelectParty from '../../../finance/party/components/SelectParty';
import { useNavigate } from 'react-router-dom';
import proposalServices from '../proposalServices';
import moment from 'moment/moment';


function ProposalForm({callBack,voucherType }) {
    const navigate = useNavigate();
    
    const[dialogStatus, setDialogStatus] = useState(false);
    const[saving,setSavingStatus] = useState(false);
    const[party,setParty] = useState(null);
    
    
    const addNew = ()=>{
        setParty(null);
        setDialogStatus(true)
    }

    const onSubmit = () =>{
        let payload = {
            partyId:party.id,
            proposalDate:moment().format(moment.HTML5_FMT.DATE)
        }
        setSavingStatus(true);
        proposalServices.save(payload).then(res=>{
            navigate("/proposal/details/"+res.id)
        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            <Tooltip title="Add New ">
                <span type="button" className="btn btn-primary" onClick={addNew}><Add style={{fontSize:18}} />{voucherType} Proposal</span>
            </Tooltip>
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>Proposal</DialogTitle>
                <DialogContent>
                    
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <SelectParty party={party} setParty={setParty} partyRole={{value:1}} /> 
                        </div>
                    </div>
                    
                    
                </DialogContent>
                
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Cancel</button>
                    <button disabled={party === null} className='btn btn-primary' onClick={onSubmit}>Continue <DoubleArrow/> </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ProposalForm